import {Action} from '@ngrx/store';
import {PagingModel} from '../models/paging-model';
import {ErrorLogResponse} from '../models/error-log-response';
import { ErrorModel } from '../models/error-model';

export const LOAD_LOG_PAGE = '[Log] LoadLogPage';
export const LOAD_LOG_PAGE_COMPLETE = '[Log] LoadLogPageComplete';

export class LoadLogPageAction implements Action {
  readonly type = LOAD_LOG_PAGE;

  constructor(public payload: PagingModel) {}
}

export class LoadLogPageCompleteAction implements Action {
  readonly  type = LOAD_LOG_PAGE_COMPLETE;

  constructor(public payload: ErrorLogResponse) {}
}

export type Actions = LoadLogPageAction |
  LoadLogPageCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/log.ts